module.exports = __webpack_public_path__ + "img/investing.0987db83.svg";